<div class="app-container">
    <app-header-menu></app-header-menu>
    <div class="main-content">
        <app-sidebar></app-sidebar>
        <div class="content-area bg-qundis-secundary">
            <div class="bg-white m-2 p-3" style="border-radius: 10px">
                <router-outlet></router-outlet>
            </div>
            <app-media-modal
                    *ngIf="modalService.getModalState('mediaSolutionModal') | async"
            ></app-media-modal>
            <app-editor-modal
                    *ngIf="modalService.getModalState('editor-ki-modal') | async"
            ></app-editor-modal>
            <app-item-form-modal
                    *ngIf="modalService.getModalState('itemFormModal') | async"
            ></app-item-form-modal>
            <app-in-progress-modal
                    *ngIf="modalService.getModalState('inProgressModal') | async"
            ></app-in-progress-modal>
            <app-edit-media-item-modal
                    *ngIf="modalService.getModalState('editMediaItemModal') | async"
            ></app-edit-media-item-modal>
            <app-escalation-modal
                    *ngIf="modalService.getModalState('escalationModal') | async"
            ></app-escalation-modal>
        </div>
    </div>
</div>
